"use client";

import { Mail, Cloud, Shield, TrendingUp, Lock, Zap, Eraser, Inbox, Settings } from "lucide-react";
import ServiceCard from "@/components/common/ui/Card";

const features = [
  {
    icon: Inbox,
    title: "Custom Mailboxes",
    description: "Create your professional appearance with name@mydomain emails exactly how you want.",
  },
  {
    icon: Mail,
    title: "POP3 / IMAP / SMTP",
    description: "Access your mail your way across all email apps and clients seamlessly.",
  },
  {
    icon: TrendingUp,
    title: "Ad-Free & Private",
    description: "Your hosted Exchange emails will NEVER be accessed, read, or scanned. Privacy guaranteed.",
  },
  {
    icon: Settings,
    title: "Exchange Manager",
    description: "Full control over permissions, storage, and mailbox creation through a simple control panel.",
  },
  {
    icon: Lock,
    title: "Anti-Spam & Anti-Virus",
    description: "Automatic triple-layer Anti-spam and Anti-virus scans keep your inbox clean.",
  },
  {
    icon: Cloud,
    title: "Cloud Network",
    description: "Dedicated Microsoft Exchange cloud storage — accessible anywhere with minimal downtime.",
  },
  {
    icon: Zap,
    title: "Push & ActiveSync",
    description: "Push-based email, appointments, and contacts from all mobile devices into Outlook.",
  },
  {
    icon: Eraser,
    title: "Delete & Recover",
    description: "Recover deleted emails from Outlook or OWA. Set retention from 0 to 30+ days.",
  },
  {
    icon: Shield,
    title: "DDoS Protection & Migration",
    description: "24/7 DDoS monitoring to protect your server, plus easy migration tools from your existing Exchange.",
  },
];

export default function AllExchangePlansInclude() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">

        {/* Header */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            All Exchange Plans Include
          </h2>
          <p className="text-gray-300 max-w-xl mx-auto">
            Enterprise-grade tools and security — built into every plan, no extras required.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <ServiceCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>

      </div>
    </section>
  );
}